// src/components/common/ScrollToTop.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    // Pega o 'pathname', que é a parte da URL após o domínio (ex: "/plugins/super-economy")
    const { pathname } = useLocation();

    // Usa um 'useEffect' que será acionado toda vez que o 'pathname' mudar
    useEffect(() => {
        // Rola a janela para as coordenadas (0, 0), ou seja, o topo absoluto da página.
        window.scrollTo(0, 0);
    }, [pathname]); // O array de dependências garante que isso só rode quando a URL mudar

    // Este componente não renderiza nada visualmente
    return null;
}